export type AccessEntry = {
  accessed_at: string;
  file_type: string;
  ip_address: string | null;
};

export type TokenEntry = {
  id: string;
  label: string;
  created_by: string;
  created_at: string;
  expires_at: string;
  max_uses_per_file: number;
  expired: boolean;
  deactivated: boolean;
  accesses: AccessEntry[];
};

export type GeneratedLinks = {
  id: string;
  label: string;
  expires_at: string;
};

export type CreateFormValues = {
  label: string;
  duration_hours: number;
  max_uses_per_file: number;
};

function parseApiDate(iso: string) {
  const hasTimezone = /(?:Z|[+-]\d{2}:?\d{2})$/.test(iso);
  return new Date(hasTimezone ? iso : `${iso}Z`);
}

export function formatDate(iso: string) {
  const d = parseApiDate(iso);
  const dd = String(d.getDate()).padStart(2, '0');
  const mmm = d.toLocaleString('en', { month: 'short' });
  const yyyy = d.getFullYear();
  const hh = String(d.getHours()).padStart(2, '0');
  const mm = String(d.getMinutes()).padStart(2, '0');
  return `${dd} ${mmm} ${yyyy} ${hh}:${mm}`;
}

export function tokenStatus(
  t: TokenEntry
): 'active' | 'deactivated' | 'expired' {
  if (t.deactivated) return 'deactivated';
  if (t.expired) return 'expired';
  return 'active';
}
